export const PERSONA_LABELS: Record<string, { name: string; description: string }> = {
    'olivia': { name: 'Olivia', description: 'Cidadã leiga, aposentada, sem conhecimento técnico' },
    'john_smith': { name: 'John Smith', description: 'Cidadão leigo com baixa visão - precisa de fontes grandes' },
    'dr_charles': { name: 'Dr. Charles', description: 'Advogado experiente - espera terminologia técnica' },
    'dra_emily': { name: 'Dra. Emily', description: 'Advogada com fotofobia - prefere modo escuro' },
    'real': { name: 'Usuário Real', description: 'Usuário com perfil real do sistema' }
};

export const TASK_LABELS: Record<string, string> = {
    'status_query': 'Consulta de Status',
    'decision_interpretation': 'Interpretação de Decisão',
    'document_location': 'Localização de Documentos'
};

export const TASK_DESCRIPTIONS: Record<string, string> = {
    'status_query': 'A persona deseja consultar a situação atual do seu processo no tribunal.',
    'decision_interpretation': 'A persona deseja entender o resultado de uma decisão judicial sobre seu caso.',
    'document_location': 'A persona deseja encontrar e acessar documentos específicos do seu processo.'
};

export const PHASE_LABELS: Record<string, string> = {
    'entry_tst': 'Entrada no TST',
    'under_review': 'Em Análise',
    'in_judgment': 'Em Julgamento',
    'decision_published': 'Decisão Publicada'
};
